<template>
  <div class="loading-container" :style="`height: ${wrapperHeight}`">
    <van-loading color="#1989fa" />
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    wrapperHeight: {
      type: String,
      default: '200px'
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>